
import window from 'window';
import { getOffset } from '../../utilities/offset';

export const elementOffset = () => {
        
    const handleOffset = (element) => {
        
        function scrollTo(topOffset) {
            const onScroll = () => {

                const scrollTop = window.scrollY;

                const relativeOffset = topOffset-scrollTop;
    
                const windowHeight = window.innerHeight;
                
                // if the relative offset is greater than half 
                // the window height, reverse the element list.
                if(relativeOffset > windowHeight/2){
                    element.classList.add("reverse");
                }
                else{
                    element.classList.remove("reverse");
                }

            }
            window.addEventListener('scroll', onScroll);
            onScroll();
        }

        const topOffset = getOffset(element).top;

        scrollTo(topOffset);
    };

    return {
        handleOffset: handleOffset
    };
};